/**
 * Custom Menu Component
 * Extends Ant Design Menu with custom styling
 */

import { Menu as AntMenu, MenuProps } from 'antd';
import classNames from 'classnames';
import './CustomMenu.scss';

export interface CustomMenuProps extends MenuProps {
  /** Menu variant */
  variant?: 'default' | 'horizontal' | 'inline' | 'vertical';
}

/**
 * CustomMenu Component
 */
export const CustomMenu: React.FC<CustomMenuProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const menuClasses = classNames('custom-menu', `custom-menu--${variant}`, className);

  return <AntMenu {...rest} className={menuClasses} />;
};

export const CustomMenuItem = AntMenu.Item;
export const CustomSubMenu = AntMenu.SubMenu;
export const CustomMenuItemGroup = AntMenu.ItemGroup;
export const CustomMenuDivider = AntMenu.Divider;

export default CustomMenu;

